// BDD 01/03/2026 schooladmin-teacher-engagement
// roles.js — single source of truth for role logic

export const ROLE = {
  TEACHER: "teacher",
  ADMIN: "admin",
  INSTITUTE_ADMIN: "institute_admin",
  SCHOOLADMIN: "schooladmin",
  SUPERADMIN: "superadmin",
};

const norm = (r) => (r || "").toLowerCase();

export const canUseTeacherTools = (role) =>
  [
    ROLE.TEACHER,
    ROLE.ADMIN,
    ROLE.INSTITUTE_ADMIN,
    ROLE.SCHOOLADMIN,
    ROLE.SUPERADMIN,
  ].includes(norm(role));

export const canUseAdminTools = (role) =>
  [ROLE.ADMIN, ROLE.INSTITUTE_ADMIN, ROLE.SCHOOLADMIN, ROLE.SUPERADMIN].includes(
    norm(role)
  );

// Optional: if you ever need a readable label
export const normalizeRole = norm;

// Mirrors backend authz.BULK_CREATE_ROLES (who may create student accounts).
// schooladmin is deliberately absent. Prefer user.can_bulk_create_users from
// /profile; this is the fallback when that flag is missing.
const BULK_CREATE_ROLES = [
  ROLE.SUPERADMIN,
  ROLE.ADMIN,
  ROLE.TEACHER,
  "teacher_admin",
  ROLE.INSTITUTE_ADMIN,
];

export const canBulkCreateInstituteUsers = (role) =>
  BULK_CREATE_ROLES.includes(norm(role).trim());
